import React from "react";
import GreBannerImage from "component/common/GreBannerImage";
import { isValidMongoObjectId, normalizeMongoId } from "utils/utils";

// GRE visitor form header — authenticated blob only (CloudFront gre_banner_url is 403).
const PropertyDeveloperBanner = ({
  propertyTitle,
  propertyId,
  className = "",
  hasBanner = null,
}) => {
  const normalizedPropertyId = normalizeMongoId(propertyId);

  if (!isValidMongoObjectId(normalizedPropertyId)) {
    return null;
  }

  if (hasBanner === false) {
    return null;
  }

  return (
    <GreBannerImage
      propertyId={normalizedPropertyId}
      propertyTitle={propertyTitle}
      className={className}
      withShell
      hasBanner={hasBanner}
      imageClassName="gre-banner-shell__image"
    />
  );
};

export default PropertyDeveloperBanner;
